<template>
  <div id="personal-infor" class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">生年月日</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-4 col-md-2 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="baseInformationStore.birth_year"
            name="birth_year"
          >
            <CustomSelect
              v-bind="field"
              :model-value="baseInformationStore.birth_year"
              :options="getYearRange()"
              :errors="errors"
              placeholder="年"
              @change="onChangeYear"
            />
            <ErrorMessage name="birth_year" class="invalid-feedback" />
          </Field>
        </div>
        <div class="col-4 col-md-2 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="baseInformationStore.birth_month"
            name="birth_month"
          >
            <CustomSelect
              v-bind="field"
              :model-value="baseInformationStore.birth_month"
              :options="getListNumber(1, 12)"
              :errors="errors"
              placeholder="月"
              @change="onChangeMonth"
            />
            <ErrorMessage name="birth_month" class="invalid-feedback" />
          </Field>
        </div>
        <div class="col-4 col-md-2 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="baseInformationStore.birth_day"
            name="birth_day"
          >
            <CustomSelect
              v-bind="field"
              :model-value="baseInformationStore.birth_day"
              :options="getListNumber(1, maxDaysInMonth)"
              :errors="errors"
              placeholder="日"
            />
            <ErrorMessage name="birth_day" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ErrorMessage, Field } from 'vee-validate';
import getListNumber from '@/utils/getListNumber';
import getYearRange from '@/utils/getYearRange';
import { useBaseInformationStore } from '@/stores/resume-candidate/BasicInformation.store';
import { computed } from 'vue';
import { isValidDate } from '@/utils/dateValidation';
import CustomSelect from '@/components/common/CustomSelect.vue';

const baseInformationStore = useBaseInformationStore();

const maxDaysInMonth = computed(() => {
  if (!baseInformationStore.birth_month) return 31;

  const year = baseInformationStore.birth_year
    ? Number(baseInformationStore.birth_year)
    : new Date().getFullYear();
  const month = Number(baseInformationStore.birth_month);

  return new Date(year, month, 0).getDate();
});

const onChangeYear = (): void => {
  if (baseInformationStore.birth_day && baseInformationStore.birth_month) {
    const currentDay = Number(baseInformationStore.birth_day);
    const currentMonth = Number(baseInformationStore.birth_month);
    const selectedYear = Number(baseInformationStore.birth_year);

    if (!isValidDate(selectedYear, currentMonth, currentDay)) {
      baseInformationStore.birth_day = undefined;
    }
  }
};

const onChangeMonth = (): void => {
  if (baseInformationStore.birth_day) {
    const currentDay = Number(baseInformationStore.birth_day);
    const selectedMonth = Number(baseInformationStore.birth_month);
    const year = baseInformationStore.birth_year
      ? Number(baseInformationStore.birth_year)
      : new Date().getFullYear();

    if (!isValidDate(year, selectedMonth, currentDay)) {
      baseInformationStore.birth_day = undefined;
    }
  }
};
</script>
